import union from 'lodash/union'
import sortBy from 'lodash/sortBy'
import dayjs from 'dayjs'

export class CampaignBudgetUtil {
  /**
   * 予算内でcreativeSchedulesの期間が途切れていないか
   */
  static isDateTimeMissing(creativeSchedules, budgetStartTime, budgetEndTime) {
    if (creativeSchedules.length < 2) return false
    const sortedSchedules = this.sortedCreativeSchedules(creativeSchedules)
    let previousEndTime = budgetStartTime
    for (let i = 0; i < sortedSchedules.length; i++) {
      const startTime = sortedSchedules[i].startTime
      if (startTime && !this.isLessThan1Second(previousEndTime, startTime)) {
        return true
      }
      previousEndTime = sortedSchedules[i].endTime
    }
    return previousEndTime
      ? !this.isLessThan1Second(previousEndTime, budgetEndTime)
      : false
  }

  static sortedCreativeSchedules(creativeSchedules) {
    const undefinedStartTimeCreativeSchedules = creativeSchedules.filter(
      cs => !cs.startTime,
    )
    const existStartTimeCreativeSchedules = creativeSchedules.filter(
      cs => cs.startTime,
    )
    return union(
      sortBy(undefinedStartTimeCreativeSchedules, ['endTime']),
      sortBy(existStartTimeCreativeSchedules, ['startTime']),
    )
  }

  /**
   * 差分が1秒未満か
   */
  static isLessThan1Second(time1, time2) {
    const timeSecondDiff = dayjs(time1).diff(time2, `second`)
    return -1 <= timeSecondDiff && timeSecondDiff <= 0
  }
}
